import type { Products } from "../types"

export const products: Products = new Map([
  [
    "euler-arbitrum",
    {
      name: "Euler Arbitrum",
      description:
        "A market tailored to facilitate common trades like blue chip lending, stablecoin borrowing, and LST/LRT looping. Governed by Euler DAO.",
      entity: ["euler-dao", "gauntlet"],
      url: "https://forum.euler.finance/t/creation-of-arbitrum-market/1501",
      vaults: [
        "0x0a1eCC5Fe8C9be3C809844fcBe615B46A869b899",
        "0x37512F45B4ba8808910632323b73783Ca938CD51",
        "0x78E3E051D32157AACD550fBB78458762d8f7edFF",
        "0xA8616E4D9f3f0aa01aff1d7c3b66249f8a5f1A58",
        "0x5A8294CE02908B1da68c6c39695c9b0FbaF7675d",
        "0x889E1c458B2469b70aCcdfb5B59726dC1668896C",
        "0x7eD866D2D66c3149FaFE854C30C68a8BA7ceE8B9",
        "0x0EE8D628411F446BFbbe08BDeF53E42414C8fBC4",
        "0xa7a9B773f139010f284E825a74060648d91dE37a",
        "0xE96e07C16661744836a742Ef2090F11e84a86f4F",
        "0xDBD974Eb5360d053ea0c56B4DaCF4A9D3E894Ee2",
        "0xaA525D3142A5BDD3E55E8e983D3789b88F2FEB8f",
        "0x1Ed564CFC30b385C9C2B184F25602764dD6A16c9",
      ],
    },
  ],
  [
    "k3-capital-usdai",
    {
      name: "K3 Capital USDai Cluster",
      entity: "k3-capital",
      vaults: [
        "0x6aFB8d3F6D4A34e9cB2f217317f4dc8e05Aa673b",
        "0x482C3E2530FAc8FE2c63AE007AD2695C6d685E98",
        "0x7D9790403FA53eF3E3a3389c259D244BDc61B785",
        "0xAABb9cbAC15a3D646dCdc6574bCFCfB989E1fDd8",
        "0x683B777A393BA94F3c903fba2b14A6b6fF80dbE7",
        "0x22038F6FA20AeacBa681030B2fb7c77155901c3F",
        "0x4d375ed67a83eDbC03685141F551DefE25b4917e",
        "0xFe3320fD1baCf38Bf74B84eF0ef7b34562926DDf",
        "0x5F7f81Fb9a3CfBF35633349990BBc5001f365408",
        "0x878e12C1a1bBDF7645E28a8e9c420ccD595204aD",
      ],
    },
  ],
  [
    "euler-arbitrum-yield",
    {
      name: "Euler Arbitrum Yield",
      entity: ["euler-dao", "gauntlet"],
      url: "https://forum.euler.finance/t/creation-of-arbitrum-yield-market/1628",
      vaults: [
        "0x05d28A86E057364F6ad1a88944297E58Fc6160b3",
        "0xF2cf48e4932835c941cCCd27e450c71138df81Ca",
        "0x5059ff3008ffE2b50980330A402ea5c59dA01AD7",
        "0x7007415237e9b1c729404A3363293e0a44EAF585",
        "0x8E8FA7c73BeF97205552456A7D41E14cAf57404D",
        "0x815ca5D298d5731a1093BA6E280019E4231465bf",
        "0xA94b187D2E767184027316cA2C6F34E80d5bef1f",
        "0x78eDA68722936f4f8BD480DFbEb9f56af6D231de",
        "0x98BeF5BE3df319D4469B3984c21449d309f8D81E",
        "0xA999f8a38A902f27F278358c4bD20fe1459Ae47C",
        "0xa5000c60AecafB2f765344e3eb5918B84F386E94",
        "0x46E57D0dE266638C8339689be04B038049Be3812",
      ],
    },
  ],
  [
    "frontier-theo",
    {
      name: "Euler Theo",
      description: "An isolated Theo ecosystem market governed by Euler DAO.",
      entity: ["euler-dao", "gauntlet"],
      vaults: [
        "0x44C10DA836d2aBe881b77bbB0b3DCE5f85C0C1Cc",
        "0xEE074ceB44adA094391B9C71A7Fb8ba6962D492c",
        "0x79e1F4a1Cde92568D58EB823f81D9c0C7C384e6b",
        "0x1e001f95599bC024eF5cd5e3CFC4C9bB52c65732",
        "0x1DA09605FEfD09312B3004212a7274D7bb1DD891",
      ],
    },
  ],
  [
    "alphagrowth-arbitrum",
    {
      name: "AlphaGrowth Arbitrum Vaults",
      description:
        "A market tailored to borrowing against blue chip crypto assets. Governed by AlphaGrowth.",
      entity: ["alphagrowth"],
      url: "https://alphagrowth.io/",
      vaults: [
        "0x124BeC4d119bc4B5d250f0b0114f2087f8EeDB57",
        "0x4aD21eBbB639c21ccd9F1eaF388Cd91D015E02ee",
        "0x8Ca487811a5e7599A5c68F49Ac1fE348371e4c46",
        "0x06b763aA769ad01F6859a56c5a856E47896e6a7F",
      ],
    },
  ],
])
